import { StyleSheet } from 'aphrodite'

import search from './search'

export default {
  search: StyleSheet.create(search)
}



// WEBPACK FOOTER //
// ./src/components/Community/Main/Main/style/ColorBlind/index.js